import { useState } from "react";
import { Button, Popconfirm, Space, Table, Typography } from "antd";
import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Show } from "@refinedev/antd";
import { AppTitle } from "components";
import { AntiDopingMaterialModal } from "./AntiDopingMaterialModal";
import { useAntiDopingMaterials } from "./useAntiDopingMaterials";
import { AntiDopingMaterial, AntiDopingMaterialFormValues } from "./types";

export const AntiDopingMaterials = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [editingMaterial, setEditingMaterial] = useState<AntiDopingMaterial>();
  const {
    loading,
    materials,
    removingIds,
    saving,
    removeMaterial,
    saveMaterial,
  } = useAntiDopingMaterials();

  const openCreateModal = () => {
    setEditingMaterial(undefined);
    setModalOpen(true);
  };

  const openEditModal = (material: AntiDopingMaterial) => {
    setEditingMaterial(material);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setEditingMaterial(undefined);
  };

  const handleSave = async (values: AntiDopingMaterialFormValues) => {
    await saveMaterial(values);
    closeModal();
  };

  return (
    <Show
      isLoading={loading}
      title={<AppTitle canGoBack>Антидопинг материалы</AppTitle>}
      breadcrumb={false}
      headerButtons={
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={openCreateModal}
        >
          Добавить материал
        </Button>
      }
      footerButtons={null}
      goBack={false}
    >
      <Table<AntiDopingMaterial>
        dataSource={materials}
        rowKey="id"
        pagination={false}
        locale={{
          emptyText: (
            <div style={{ margin: 56 }}>Антидопинг материалы отсутствуют</div>
          ),
        }}
      >
        <Table.Column<AntiDopingMaterial>
          dataIndex="fileName"
          key="fileName"
          title="Название"
        />
        <Table.Column<AntiDopingMaterial>
          dataIndex="linkUrl"
          key="linkUrl"
          title="Файл"
          render={(value) => (
            <Typography.Link href={value} target="_blank" rel="noreferrer">
              {value}
            </Typography.Link>
          )}
        />
        <Table.Column<AntiDopingMaterial>
          width={220}
          fixed="right"
          key="actions"
          title="Действия"
          render={(_, record) => (
            <Space size={8} direction="vertical" style={{ width: "100%" }}>
              <Button
                size="small"
                icon={<EditOutlined />}
                onClick={() => openEditModal(record)}
                block
              >
                Редактировать
              </Button>
              <Popconfirm
                title="Удалить материал?"
                okText="Удалить"
                cancelText="Отмена"
                onConfirm={() => removeMaterial(record.id)}
              >
                <Button
                  danger
                  size="small"
                  icon={<DeleteOutlined />}
                  loading={removingIds.includes(record.id)}
                  block
                >
                  Удалить
                </Button>
              </Popconfirm>
            </Space>
          )}
        />
      </Table>

      <AntiDopingMaterialModal
        open={modalOpen}
        saving={saving}
        material={editingMaterial}
        onCancel={closeModal}
        onSubmit={handleSave}
      />
    </Show>
  );
};
